// Legenda clicável dos mapas de OS: cada linha liga/desliga a exibição das OSs
// daquela faixa de cor. Usada pelo mapa do dashboard e por /maps/service_orders.
// Depende de window.ServiceOrderMapColors (app/javascript/maps/service_order_colors.js).

const HIDDEN_OPACITY = '0.4';

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function swatchHtml(color, hidden) {
  const background = hidden ? 'transparent' : color;
  return '<span class="map-legend" data-legend-color="' + escapeHtml(color) + '"' +
    ' style="display: inline-block; width: 12px; height: 12px;' +
    ' border-radius: 50%; margin-right: 8px; box-sizing: border-box;' +
    ' border: 2px solid ' + color + '; background-color: ' + background + ';"></span>';
}

function itemHtml(item, hidden) {
  const style = 'margin: 2px 0; display: flex; align-items: center; cursor: pointer;' +
    ' user-select: none;' +
    (hidden ? ' opacity: ' + HIDDEN_OPACITY + '; text-decoration: line-through;' : '');

  return '<div class="legend-item legend-item--toggle" data-legend-key="' + escapeHtml(item.key) + '"' +
    ' role="button" tabindex="0" title="Clique para mostrar/ocultar no mapa" style="' + style + '">' +
    swatchHtml(item.color, hidden) +
    '<span>' + escapeHtml(item.label) +
    ' <small style="color: #6c757d;">(' + item.count + ')</small></span></div>';
}

function groupHtml(group, hidden) {
  let html = group.name
    ? '<div style="border-left: 3px solid #ddd; padding-left: 10px; margin-left: 10px;"><strong>' +
      escapeHtml(group.name) + '</strong><br>'
    : '<div>';

  group.items.forEach((item) => {
    html += itemHtml(item, !!hidden[item.key]);
  });

  return html + '</div>';
}

function headerHtml(mode) {
  return '<div style="display: flex; justify-content: space-between; align-items: center;' +
    ' flex-wrap: wrap; gap: 10px;">' +
    '<h5 style="margin: 0;">' + window.ServiceOrderMapColors.legendTitle(mode) + '</h5>' +
    '<div>' +
    '<button type="button" class="btn btn-sm btn-default" data-legend-action="show-all">Mostrar todas</button> ' +
    '<button type="button" class="btn btn-sm btn-default" data-legend-action="hide-all">Ocultar todas</button>' +
    '</div></div>' +
    '<small style="color: #6c757d;">Clique numa faixa da legenda para mostrar ou ocultar as OSs dela no mapa.</small>';
}

function create(config) {
  const container = typeof config.container === 'string'
    ? document.getElementById(config.container)
    : config.container;
  const bucketOptions = config.bucketOptions || {};
  const onChange = config.onChange || function () {};

  let mode = null;
  let hidden = {};
  let model = [];

  function render(data, currentDate) {
    model = window.ServiceOrderMapColors.legendModelFrom(data, mode, currentDate, bucketOptions);

    let html = headerHtml(mode);
    html += '<div style="display: flex; flex-wrap: wrap; gap: 15px; margin-top: 10px;">';
    model.forEach((group) => {
      html += groupHtml(group, hidden);
    });
    html += '</div>';

    container.innerHTML = html;
  }

  function redraw() {
    const rows = container.querySelectorAll('[data-legend-key]');
    Array.prototype.forEach.call(rows, (row) => {
      const isHidden = !!hidden[row.getAttribute('data-legend-key')];
      row.style.opacity = isHidden ? HIDDEN_OPACITY : '';
      row.style.textDecoration = isHidden ? 'line-through' : '';
      const swatch = row.querySelector('[data-legend-color]');
      if (swatch) {
        swatch.style.backgroundColor = isHidden ? 'transparent' : swatch.getAttribute('data-legend-color');
      }
    });
  }

  function toggle(key) {
    if (hidden[key]) {
      delete hidden[key];
    } else {
      hidden[key] = true;
    }
    redraw();
    onChange();
  }

  function showAll() {
    hidden = {};
    redraw();
    onChange();
  }

  function hideAll() {
    model.forEach((group) => {
      group.items.forEach((item) => {
        hidden[item.key] = true;
      });
    });
    redraw();
    onChange();
  }

  // O container sobrevive à recriação do mapa (dashboard), então descarta o
  // listener da instância anterior para não empilhar cliques duplicados.
  if (container.soLegendClickHandler) {
    container.removeEventListener('click', container.soLegendClickHandler);
  }

  const onClick = (event) => {
    const action = event.target.closest('[data-legend-action]');
    if (action) {
      event.preventDefault();
      if (action.getAttribute('data-legend-action') === 'show-all') {
        showAll();
      } else {
        hideAll();
      }
      return;
    }

    const row = event.target.closest('[data-legend-key]');
    if (row) {
      toggle(row.getAttribute('data-legend-key'));
    }
  };

  const onKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const row = event.target.closest('[data-legend-key]');
    if (row) {
      event.preventDefault();
      toggle(row.getAttribute('data-legend-key'));
    }
  };

  if (container.soLegendKeydownHandler) {
    container.removeEventListener('keydown', container.soLegendKeydownHandler);
  }

  container.soLegendClickHandler = onClick;
  container.soLegendKeydownHandler = onKeydown;
  container.addEventListener('click', onClick);
  container.addEventListener('keydown', onKeydown);

  return {
    // Trocar o modo de cor muda o sentido das chaves, então limpa o filtro.
    setMode(newMode) {
      if (newMode !== mode) {
        mode = newMode;
        hidden = {};
      }
    },
    render,
    isVisible(serviceOrder, currentDate) {
      const bucket = window.ServiceOrderMapColors.markerBucket(serviceOrder, mode, currentDate, bucketOptions);
      return !hidden[bucket.key];
    }
  };
}

window.ServiceOrderMapLegend = { create };
